/**
 * Currency definition service for fetching master currency list
 */

import { apiClient } from '@/lib/api'

export interface CurrencyDefinition {
  code: string
  name: string
  symbol?: string
  is_common: boolean
  is_active: boolean
  display_order: number
}

export interface CurrencyDefinitionsGrouped {
  common: CurrencyDefinition[]
  other: CurrencyDefinition[]
}

/**
 * Fetch all currency definitions grouped by common and other
 */
export async function fetchCurrencyDefinitions(): Promise<CurrencyDefinitionsGrouped> {
  return await apiClient.get<CurrencyDefinitionsGrouped>(
    '/currency-definitions'
  )
}

/**
 * Get count of invoices that would be affected by changing the shared rate
 *
 * @param currencyCode - ISO currency code (e.g., 'USD')
 * @param rateDate - Date in ISO format (YYYY-MM-DD)
 * @param excludeInvoiceId - Optional invoice ID to exclude from count
 */
export async function fetchAffectedInvoicesCount(
  currencyCode: string,
  rateDate: string,
  excludeInvoiceId?: string
): Promise<number> {
  let url = `/currency-definitions/affected-invoices-count?currency_code=${currencyCode}&rate_date=${rateDate}`
  if (excludeInvoiceId) {
    url += `&exclude_invoice_id=${excludeInvoiceId}`
  }
  const response = await apiClient.get<{ count: number }>(url)
  return response.count
}
